module.exports = __webpack_public_path__ + "img/HK.b0af3d97.svg";